import { useReanimatedKeyboardAnimation } from "react-native-keyboard-controller"
import A, { useAnimatedStyle } from "react-native-reanimated"
import { useSafeAreaInsets } from "react-native-safe-area-context"

export function KeyboardSpacer({ withoutSafeArea }: { withoutSafeArea?: boolean }) {
  const insets = useSafeAreaInsets()
  const tabBarHeight = 50 // useBottomTabBarHeight()
  const { height } = useReanimatedKeyboardAnimation()

  const style = useAnimatedStyle(() => {
    return { height: height.value * -1 - ((withoutSafeArea ? 0 : insets.bottom) + tabBarHeight) }
  }, [])

  return <A.View style={style} />
}
